<!--
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2021-08-11 14:48:11
 * @LastEditors: 聂章帅
 * @LastEditTime: 2021-10-14 11:30:43
-->
<template>
  <div>
    <div class="home">
      <First v-if="$route.query.type == 1 || !$route.query.type"></First>
      <Second></Second>
      <Third v-if="$route.query.type == 1 || !$route.query.type"></Third>
    </div>
    <div class="appImage" v-if="cityDetail.showAppImage && cityDetail.appImage">
      <div class="phoneIcon">
        <i class="el-icon-mobile-phone"></i>
        <span>福农通App</span>
        <div class="image">
          <img :src="cityDetail.appImage" alt="" />
        </div>
      </div>
    </div>
    <!-- <YQLJ></YQLJ> -->
  </div>
</template>

<script>
// @ is an alias to /src
import First from '@/components/Home/First.vue'
import Second from '@/components/Home/Second.vue'
import Third from '@/components/Home/Third.vue'
import YQLJ from '@/components/Home/Third/友情链接.vue'
import { cityDetail } from '../util/mainOption'

export default {
  data () {
    return {
      time: '',
    }
  },
  components: {
    First,
    Second,
    Third,
    YQLJ,
  },
  created () {
    this.time = this.today()
  },
  methods: {
    today () {
      var d = new Date(),
        show_day = new Array(
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ),
        day = d.getDay(),
        str = ''
      str += d.getFullYear() + '年' //获取当前年份
      str += d.getMonth() + 1 + '月' //获取当前月份（0——11）
      str += d.getDate() + '日'
      str += ' ' + show_day[day]
      // str += d.getHours() + '时';
      // str += d.getMinutes() + '分';
      // str += d.getSeconds() + '秒';
      // console.log(str);
      return str
    },
  },
}
</script>
<style scoped lang="scss">
.home {
  /* z-index: 12; */
  margin: 0 auto;
  /* padding: 5px 28px 35px 28px; */
  /* padding: 5px 18px 35px 18px; */
  width: 1864px;
  height: auto;
  /* background-color: #f5f5f5; */
  /* background-color: chocolate; */
}

.time {
  width: 100%;
  height: 32px;
  background-color: rgb(233, 233, 233);
  overflow: hidden;
  margin-bottom: 10px;
  color: rgb(123, 123, 123);
  font-size: 24px;
}

.time > span {
  padding-left: 68px;
  width: auto;
  height: 84px;
  font-size: 28px;
  line-height: 84px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.appImage {
  position: fixed;
  right: 30px;
  top: 70%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
}
.appImage > .phoneIcon {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  background-color: #409eff;
  padding: 10px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  position: relative;
}
.appImage > .phoneIcon > i {
  color: #fff;
  font-size: 28px;
}
.appImage > .phoneIcon > span {
  color: #fff;
  font-size: 18px;
  margin-top: 5px;
}
.appImage > .phoneIcon > .image {
  position: absolute;
  right: 50%;
  bottom: calc(100% + 10px);
  transform: translateX(50%);
  width: 150px;
  height: auto;
  display: none;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
}
.appImage > .phoneIcon > .image > img {
  width: 100%;
  height: auto;
  display: block;
}
.appImage > .phoneIcon:hover > .image {
  display: block;
}
</style>
